import script from "./Listing.vue?vue&type=script&setup=true&lang=js"
export * from "./Listing.vue?vue&type=script&setup=true&lang=js"

import "./Listing.vue?vue&type=style&index=0&id=672779f8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/wp-content/themes/stewartrealtor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672779f8"]])

export default __exports__